export const config = {
  axes: {
    y: {
      show: true,
      tickSizeInner: 5,
      tickLineColour: "grey",
      domainColour: "grey",
      textColour: "grey",
    },
    x: {
      show: true,
      tickSizeInner: 5,
      tickLineColour: "grey",
      domainColour: "grey",
      textColour: "grey",
    },
  },
  layout: {
    margin: {
      top: 40,
      right: 20,
      bottom: 30,
      left: 50,
    },
  },
  svg: { Background: "#ffffff", border: "none" },
  border: { stroke: "#f6f6f6", strokeWidth: 1 },
  header: {
    text: "",
    colour: "#CBA266",
    fontSize: 14,
    fontWeight: 600,
    margin: { left: 10, top: 20 },
  },
};
